import { render, staticRenderFns } from "./LoginOtpCustom.vue?vue&type=template&id=35fadf76&scoped=true"
import script from "./LoginOtpCustom.vue?vue&type=script&lang=js"
export * from "./LoginOtpCustom.vue?vue&type=script&lang=js"
import style0 from "./LoginOtpCustom.vue?vue&type=style&index=0&id=35fadf76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fadf76",
  null
  
)

export default component.exports